import { useBackendApi } from 'nekst-api';

export type CopyTasksRequest = {
  sourcePlanId: number,
  targetPlansIds: number[],
  tasksIds: number[],
}

export function useCopyTasksService() {
  const nekstApi = useBackendApi();

  const copyTasks = async (request: CopyTasksRequest) => {
    await nekstApi.put('/plantasks/bulk/copy', request);
  };

  return {
    copyTasks,
  };
}
